(function($) {
    'use strict';

    jQuery(document).ready(function($) {
        //character countdown
        function initCharLimitCounter() {
            var $textareas = $( 'textarea' ).filter(function() {
                return ! $(this).data('charlimit-initialized');
            });

            //add div to show characters left
            $textareas.each(function(){
                if (!$(this).next().hasClass('charlimit')) {
                    $(this).after($( '<div class="charlimit"></div>' ));
                    $(this).data('charlimit-initialized', true);
                }
            });
            
        }

        initCharLimitCounter();

        $(document).on('repeatable-reinit', initCharLimitCounter);

        $(document).on('keypress input change focus', 'textarea', function(e) {
            var maxLength = $(this).data('char-limit');

            if (!maxLength) {
                return;
            }

            var length = $(this).val().length;
            var length = maxLength-length;

            $(this).parent().find( '.charlimit' ).text( length );
        });
    });

})(jQuery);